<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                 <BreadCrumbs :crumbsParams="breadCrumbsDetails" />
              </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>All Notifications
                        <a href="" v-if="showMarkAllButton" @click.prevent="markAllAsRead"  class="btn btn-md btn-primary float-right">Mark all as read</a>
                    </h4>

                </div>
            </section>
        </div>

<div class="card p-1 content-body">
<!-- <div class="app-content-overlay"></div> -->
     
        <div v-for="row in rows" :key="row.id" style="color:black">
            <div :style="`background-color:  ${row.read_at || changeColor.includes(row.id) ? '#E5E4E2' : '#8C1111'}; color:  ${row.read_at || changeColor.includes(row.id) ? 'black' : 'white'};`"  :class="`alert alert-dismissible fade show`" role="alert">
            <!-- <div :style="`background-color:  ${row.read_at || changeColor.includes(row.id) ? '#7FFFD4':'#E5E4E2'};`"  :class="`alert alert-dismissible fade show`" role="alert"> -->
               <Link href="javascript:void(0);" :style="`color:  ${row.read_at || changeColor.includes(row.id) ? 'black' : 'white'}; font-style: italic`"  @click.prevent="markAsRead(row.id)"  preserve-scroll >{{ row.title }} &nbsp;&nbsp;&nbsp;<span class="float-right" :style="`color:  ${row.read_at || changeColor.includes(row.id) ? 'black' : 'white'};`">{{ row.created_at }}</span></Link>
               <div v-if="row.read_at || changeColor.includes(row.id)">{{ row.body }}</div>
            </div>
        </div>
        <Pagination :links="links" />

</div>
     
    </div>
</template>

<script>

import Layout from '@/Shared/Layout';
import BreadCrumbs from '@/Shared/BreadCrumbs';
import ActionLinks from '@/Shared/ActionLinks';
import Pagination from '@/Shared/Paginate';
import { Inertia } from '@inertiajs/inertia';
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';

import { Link } from '@inertiajs/inertia-vue';
import { Router } from '@inertiajs/inertia-vue';



export default {
    metaInfo: {title: 'notifications'},
    props: ['notifications'],
    layout: Layout,
    components:{
        ActionLinks,
        BreadCrumbs,
        VueGoodTable,
        Link,
        Pagination,
    },
    data() {
    return {
           breadCrumbsDetails: {
                link: "admin.notifications.unreadNotifications",
                linkPage: "Unread Notifications",
                currentPage: "All Notifications",
           },
           links: {},
           changeColor: [],
           showMarkAllButton: true,
           rows: this.notifications.data,
           columns: [
            {label: 'Date Sent', field: 'created_at'},
            {label: 'Title', field: 'title'},
            {label: 'Body', field: 'body'},
            // { label: 'Status', field: 'status' },
            {label: 'Action', field: 'action'},
            
           ]
        }
    },
    methods: {
        showDetails(id){

        },
        async markAsRead(id){
            // console.log('e dey work'+this.rows);
            await this.$inertia.post(route('admin.notifications.markAsRead',id));
            this.changeColor.push(id); 
            console.log(this.changeColor);
            // this.rows = await this.$inertia.get(route('admin.notifications.index'));          
        },
        markAllAsRead(){
            // console.log('e dey workeeee');
                Swal.fire({
                title: 'Are you sure to mark all as read?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!',
                }).then((result) => {
                if (result.value) {
                   this.$inertia.post(route('admin.notifications.markAllAsRead'));
                    
                    setTimeout(() => {
                    document.location.reload();
                    }, 3000);

                    Swal.fire(
                    'Success',
                    'All marked as read!',
                    'success'
                    )
                    }else if(result.dismiss == 'cancel'){
                        Swal.fire(
                        'Ops!',
                        'You cancelled this action',
                        'info'
                        )
                    }else{
                        Swal.fire(
                        'Ops!',
                        'The intented action was not successful',
                        'error'
                    )
                }
                })
            // }


        }
    },
    mounted() {
             this.rows = this.notifications.data;
             this.showMarkAllButton = this.notifications.data[0].show_mark_all_button;
             this.links = this.notifications.links;
    },
}
</script>
